'use client';
import React from 'react';
import Link from 'next/link';
import VisibilityTracker from '@/app/ui/components/tracking/visibilityTracker';
import { PAGE_TYPES } from '@/app/constants';
import { trackSSTEvent } from '@/app/utils/tracking';
import FollowBrands from '@/app/ui/components/profile/followBrands';

type Breadcrumbs = {
  breadcrumbs: {
    name: string;
    url: string;
  }[];
  title?: string;
  pageType?: PAGE_TYPES;
  brandSeoContent?: boolean;
  lastAsUrl?: boolean;
  brandId?: number;
  isBrandMainPage?: boolean;
  apiUrl?: string;
};

export function Breadcrumbs({
  breadcrumbs,
  title,
  pageType,
  brandSeoContent,
  lastAsUrl,
  brandId,
  isBrandMainPage,
  apiUrl,
}: Breadcrumbs) {
  const clickEvents = () => {
    if (!pageType) return;
    const eventName = pageType === PAGE_TYPES.LIST ? 'plp_breadcrumbs_click' : 'pdp_breadcrumbs_click';
    trackSSTEvent(eventName, null);
  };
  return (
    <>
      <ul
        data-testid="breadcrumbs"
        className="p-0 d-flex text-overflow-scroll no-scrollbar breadcrumbs"
        style={{
          listStyleType: 'none',
        }}>
        {breadcrumbs.map((breadcrumb, index) => {
          const isLast = index === breadcrumbs.length - 1;

          if (isLast && !lastAsUrl) {
            return (
              <li key={breadcrumb.name} className="text-capitalize text-black-50">
                {breadcrumb.name}
              </li>
            );
          }
          return (
            <li key={breadcrumb.name}>
              <Link
                href={breadcrumb.url}
                className={'text-decoration-none text-black text-capitalize'}
                onClick={clickEvents}>
                {breadcrumb.name}
              </Link>
              {index < breadcrumbs.length - 1 && <span className="px-1">/</span>}
            </li>
          );
        })}
      </ul>
      {pageType && (
        <VisibilityTracker
          eventName={pageType === PAGE_TYPES.LIST ? 'plp_breadcrumbs_display' : 'pdp_breadcrumbs_display'}
          data={null}
        />
      )}
      {title && brandSeoContent && (
        <div className={'d-flex'}>
          <h1 className="mb-3 main-headline">{title}</h1>
          {isBrandMainPage && <FollowBrands brandId={brandId?.toString()} apiUrl={apiUrl} />}
        </div>
      )}
    </>
  );
}
